import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';

import type { IIntegrationUIOption, IIntegrationUISelectSettingField } from '@feathr/components';
import { Tooltip, UniversalSelect } from '@feathr/components';

import * as styles from './CrmOptionSelect.css';

interface IProps {
  /** The field from the config: its label and placeholder. */
  field: IIntegrationUISelectSettingField;
  /** `undefined` while the options load. */
  options: readonly IIntegrationUIOption[] | undefined;
  /** The selected option's id. */
  value: string | null | undefined;
  onSelect: (option: IIntegrationUIOption) => void;
  noOptionsMessage: string;
  name: string;
  /** Disables the select with this reason, e.g. while the page saves. */
  disabledReason?: string;
}

/** A searchable select for a CRM option a toggle needs, such as a fund or a project. */
function CrmOptionSelect({
  disabledReason,
  field,
  name,
  noOptionsMessage,
  onSelect,
  options,
  value,
}: Readonly<IProps>): JSX.Element {
  function getNoOptionsMessage(): string {
    return noOptionsMessage;
  }

  return (
    <Tooltip className={styles.tooltip} title={disabledReason}>
      <UniversalSelect<IIntegrationUIOption>
        controlPrefix={<FontAwesomeIcon icon={faMagnifyingGlass} />}
        disabled={Boolean(disabledReason)}
        isLoading={options === undefined}
        isMulti={false}
        label={field.label}
        name={name}
        noOptionsMessage={getNoOptionsMessage}
        onSelectSingle={onSelect}
        options={options ?? []}
        placeholder={field.placeholder}
        value={options?.find((option) => option.id === value) ?? null}
      />
    </Tooltip>
  );
}

export default CrmOptionSelect;
